<div class="offer-details-container">
    <div class="nova-toolbar__pre-header space-between items-center">
        <div class="white-text flex-row justify-start items-center">
            <mat-icon (click)="goBack()">arrow_back</mat-icon>
            <div class="title">Create New Offer</div>
        </div>
        @if (isOfferOptimizationsEnabled) {
            <div class="button-actions">
                <button
                    mat-raised-button
                    type="submit"
                    [disabled]="detailsFormGroup.invalid || disableSubmitAndCancel"
                    color="primary"
                    (click)="createOffer()">
                    <span
                        [matTooltip]="'Please enter appropriate fields to create the offer.'"
                        [matTooltipDisabled]="detailsFormGroup.valid">
                        Create Offer
                    </span>
                </button>
                <button
                    mat-stroked-button
                    type="button"
                    color="secondary"
                    (click)="cancelCreateOffer()"
                    [disabled]="disableSubmitAndCancel"
                    >Cancel</button
                >
            </div>
        } @else {
            <div class="button-actions">
                <button
                    mat-stroked-button
                    type="button"
                    color="secondary"
                    (click)="cancelCreateOffer()"
                    [disabled]="disableSubmitAndCancel"
                    >Cancel</button
                >
                <button
                    mat-raised-button
                    type="submit"
                    [disabled]="detailsFormGroup.invalid || disableSubmitAndCancel"
                    color="primary"
                    (click)="createOffer()">
                    <span
                        [matTooltip]="'Please enter appropriate fields to create the offer.'"
                        [matTooltipDisabled]="detailsFormGroup.valid">
                        Create Offer
                    </span>
                </button>
            </div>
        }
    </div>
    <ng-container>
        <nova-banner
            *ngIf="validateCandidateProfessionJobs"
            bannerType="alert"
            bannerMessage="Clinician's profession must match the job's profession. Please review and update before creating an Offer.">
        </nova-banner>
    </ng-container>
    @if (isOfferOptimizationsEnabled) {
        <div class="create-apn-offer-container flex-row gap-16">
            <div class="left-column">
                <form [formGroup]="detailsFormGroup">
                    <div class="form-content flex-col gap-24 pd-14">
                        <mat-card class="details__info-card">
                            <mat-card-header>
                                <mat-card-title>Important Details</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="flex-col flex-1">
                                    <mat-form-field>
                                        <textarea
                                            matInput
                                            formControlName="otherDetails"
                                            class="other-notes-textarea"></textarea>
                                        <mat-hint align="end"
                                            >{{ detailsFormGroup.controls.otherDetails.value?.length }}/1500
                                            characters</mat-hint
                                        >
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card>
                            <mat-card-header>
                                <mat-card-title>Internal Offer Details</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Vendor*</mat-label>
                                    <mat-form-field class="details__item--control">
                                        <input
                                            type="text"
                                            matInput
                                            formControlName="vendorValues"
                                            [matAutocomplete]="vendorAuto" />
                                        <mat-autocomplete
                                            #vendorAuto="matAutocomplete"
                                            [displayWith]="displayFieldName"
                                            (optionSelected)="agencySelection($event)">
                                            @for (option of filteredVendorIdOptions | async; track option) {
                                                <mat-option
                                                    [value]="option"
                                                    [disabled]="!option.hasAcceptedFacilities">
                                                    {{ option.name }}
                                                    {{
                                                        !option.hasAcceptedFacilities ? '(No Accepted Facilities)' : ''
                                                    }}
                                                </mat-option>
                                            }
                                        </mat-autocomplete>
                                        @if (hasError('vendorValues', 'required')) {
                                            <mat-error>Vendor is required</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Vendor Contact*</mat-label>
                                    <mat-form-field class="details__item--control">
                                        <mat-select formControlName="vendorContactId">
                                            @for (option of vendorLookup?.contacts; track option) {
                                                <mat-option [value]="option.id">{{ option.name }}</mat-option>
                                            }
                                        </mat-select>
                                        @if (hasError('vendorContactId', 'required')) {
                                            <mat-error>Vendor Contact is required</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Candidate*</mat-label>
                                    <mat-form-field class="details__item--control">
                                        <input
                                            type="text"
                                            matInput
                                            formControlName="selectedCandidate"
                                            [errorStateMatcher]="matcher"
                                            [matAutocomplete]="candidateAuto" />
                                        <mat-autocomplete
                                            #candidateAuto="matAutocomplete"
                                            (optionSelected)="candidateSelection($event)"
                                            [displayWith]="displayFieldName"
                                            autoActiveFirstOption
                                            #auto="matAutocomplete">
                                            @for (option of filteredCandidateIdOptions | async; track option) {
                                                <mat-option
                                                    [value]="option"
                                                    [disabled]="!option.userId">
                                                    {{ option.name }}
                                                    {{ !option.userId ? '(no profile)' : '' }}
                                                </mat-option>
                                            }

                                            @if (!filteredCandidateIdOptions) {
                                                <mat-option> No candidates available to choose from. </mat-option>
                                            }
                                        </mat-autocomplete>
                                        <mat-error>Please enter a Candidate.</mat-error>
                                    </mat-form-field>
                                    @if (detailsFormGroup?.controls.selectedCandidate.value) {
                                        <span class="candidate-email">
                                            {{ detailsFormGroup?.controls.candidateEmail.value }}
                                        </span>
                                    }
                                </div>
                                <div class="details__item--gap flex-row gap-16">
                                    <mat-label class="details__item--label">AM</mat-label>
                                    <span>{{ facilityLookup?.accountManager }}</span>
                                </div>
                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Contract Type</mat-label>
                                    <mat-form-field class="details__item--control">
                                        <mat-select formControlName="contractTypeId">
                                            @for (option of lookups?.contracts; track option) {
                                                <mat-option [value]="option.id">{{ option.code }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Job ID</mat-label>
                                    <mat-form-field class="details__item--control">
                                        <input
                                            type="number"
                                            matInput
                                            formControlName="jobId"
                                            [matAutocomplete]="jobIdAuto"
                                            (change)="jobIdSelection($event)" />
                                        <mat-autocomplete
                                            #jobIdAuto="matAutocomplete"
                                            [displayWith]="displayJobIds"
                                            (optionSelected)="jobIdSelection($event)">
                                            @for (job of filteredJobIdOptions | async; track job) {
                                                <mat-option [value]="job">{{ job }}</mat-option>
                                            }
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>
                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Facility Rate</mat-label>
                                    <mat-form-field class="details__item--control">
                                        <input
                                            type="number"
                                            matInput
                                            formControlName="facilityRate"
                                            (keyup)="updateVendorRate()"
                                            (change)="calculateContractDates('facilityRateChanged')" />
                                        <span matTextPrefix>$</span>
                                    </mat-form-field>
                                </div>
                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Vendor Rate</mat-label>
                                    <mat-form-field class="details__item--control">
                                        <input
                                            type="number"
                                            matInput
                                            formControlName="vendorRate" />
                                        <span matTextPrefix>$</span>
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card>
                            <mat-card-header>
                                <mat-card-title>Candidate Offer Details</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">System</mat-label>
                                    <mat-form-field class="details__item--control--extended">
                                        <input
                                            type="text"
                                            matInput
                                            formControlName="systemValues"
                                            [matAutocomplete]="systemAuto" />

                                        <mat-autocomplete
                                            #systemAuto="matAutocomplete"
                                            [displayWith]="displayFieldName"
                                            (optionSelected)="systemSelection($event)">
                                            @if (!filteredSystemIdOptions) {
                                                <mat-option>No systems available to choose from.</mat-option>
                                            }
                                            @for (option of filteredSystemIdOptions | async; track option) {
                                                <mat-option [value]="option">{{ option.name }}</mat-option>
                                            }
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>
                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Facility*</mat-label>
                                    <mat-form-field class="details__item--control--extended">
                                        <input
                                            matInput
                                            type="text"
                                            formControlName="facilityValues"
                                            [matAutocomplete]="facilityAuto"
                                            [errorStateMatcher]="matcher" />
                                        <mat-autocomplete
                                            #facilityAuto="matAutocomplete"
                                            [displayWith]="displayFieldName"
                                            (optionSelected)="facilitySelection($event)">
                                            @if (!filteredFacilityIdOptions) {
                                                <mat-option>No facilities available to choose from.</mat-option>
                                            }
                                            @for (facility of filteredFacilityIdOptions | async; track facility) {
                                                <mat-option [value]="facility">
                                                    {{ facility.name }} - {{ facility.id }}
                                                </mat-option>
                                            }
                                        </mat-autocomplete>
                                        @if (hasError('facilityValues', 'required')) {
                                            <mat-error>Facility is required</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                                <div class="details__item--gap flex-row gap-16">
                                    <mat-label class="details__item--label">Position Type</mat-label>
                                    <span>{{ candidateProfessionTypeName }}</span>
                                </div>
                                <div class="details__item--gap flex-row gap-16">
                                    <mat-label class="details__item--label">Candidate Profession</mat-label>
                                    <span>{{ candidateProfessionName }}</span>
                                </div>
                                <div class="details__item--gap flex-row gap-16">
                                    <mat-label class="details__item--label">Job Profession</mat-label>
                                    <span>{{ jobProfessionName }}</span>
                                </div>
                                @if (validateCandidateProfessionJobs) {
                                    <div class="details__item flex-row gap-16">
                                        <mat-label class="details__item--label"></mat-label>

                                        <mat-error class="flex-1"
                                            >Clinician's profession must match the job's profession. Please review and
                                            update before creating an Offer.</mat-error
                                        >
                                    </div>
                                }
                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Job Specialty</mat-label>
                                    <mat-form-field class="details__item--control">
                                        <mat-select
                                            formControlName="expertiseId"
                                            (selectionChange)="checkRateUpdateFields('Expertise')"
                                            [disabled]="!detailsFormGroup.controls.candidateProfessionId.value">
                                            @for (option of expertise; track option) {
                                                <mat-option [value]="option.id">{{ option.name }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Contract Length</mat-label
                                    ><div class="contract-length flex-col">
                                        <div>
                                            <mat-form-field class="details__item--control">
                                                <input
                                                    type="number"
                                                    matInput
                                                    (change)="calculateContractDates('weeksLengthChanged')"
                                                    formControlName="contractLength" />
                                                <mat-error>Please enter valid Weeks Length.</mat-error>
                                            </mat-form-field>
                                            <span class="label-text"> Weeks</span>
                                        </div>
                                        <div>
                                            <mat-form-field class="details__item--control">
                                                <input
                                                    type="number"
                                                    matInput
                                                    (change)="calculateContractDates('daysLengthChanged')"
                                                    formControlName="contractLengthDays" />
                                                <mat-error>Please enter valid Days Length.</mat-error>
                                            </mat-form-field>
                                            <span class="label-text"> Days</span>
                                            @if (contractLengthDaysApprovalRequired) {
                                                <mat-icon
                                                    class="info-icon"
                                                    [matTooltip]="contractLengthDaysInfoMessage"
                                                    >info</mat-icon
                                                >
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Start*</mat-label>
                                    <mat-form-field class="details__item--control">
                                        <input
                                            matInput
                                            [matDatepicker]="picker"
                                            formControlName="startDate"
                                            (dateChange)="calculateContractDates('startDateChanged')"
                                            data-qa-id="StartDateInput" />
                                        <mat-datepicker-toggle
                                            matSuffix
                                            [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        @if (detailsFormGroup.controls['startDate'].invalid) {
                                            <mat-error>Please enter valid start date.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">End*</mat-label>
                                    <mat-form-field class="details__item--control">
                                        <input
                                            matInput
                                            [matDatepicker]="endPicker"
                                            formControlName="endDate"
                                            [min]="minEndDate"
                                            (dateChange)="calculateContractDates('endDateChanged')"
                                            data-qa-id="EndDateInput" />
                                        <mat-datepicker-toggle
                                            matSuffix
                                            [for]="endPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #endPicker></mat-datepicker>
                                        @if (detailsFormGroup.controls['endDate'].invalid) {
                                            <mat-error>Please enter valid end date.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div class="details__item--gap flex-row gap-16">
                                    <mat-label class="details__item--label">RTO</mat-label>
                                    <mat-checkbox formControlName="hasRequestedTimeOff"></mat-checkbox>
                                </div>

                                @if (detailsFormGroup.controls.hasRequestedTimeOff.value) {
                                    <div class="details__item--gap flex-row gap-16">
                                        <mat-label class="details__item--label">RTO Dates</mat-label>
                                        <div class="flex-col gap-4">
                                            <div class="flex-row">
                                                <div class="rto-container">
                                                    <div class="calendar-control">
                                                        <div class="days">
                                                            <span>{{ daysRequested }}</span>
                                                        </div>
                                                        <button
                                                            class="rto-btn"
                                                            mat-icon-button
                                                            [matMenuTriggerFor]="appMenu">
                                                            <mat-icon>event</mat-icon>
                                                        </button>
                                                    </div>
                                                    <mat-menu
                                                        #appMenu="matMenu"
                                                        class="drop-calendar">
                                                        <div
                                                            (click)="$event.stopPropagation()"
                                                            (keydown.enter)="$event.stopPropagation()">
                                                            <mat-calendar
                                                                #calendar
                                                                class="mat-calendar"
                                                                [dateClass]="dateClass()"
                                                                [maxDate]="maxDate"
                                                                [minDate]="minDate"
                                                                (selectedChange)="dateChanged($event)">
                                                            </mat-calendar>
                                                        </div>
                                                    </mat-menu>
                                                    <a
                                                        class="nova-link rto-clear__btn"
                                                        [class.disabled]="daysSelected.length ? false : true"
                                                        (click)="clearDates()"
                                                        (keydown.enter)="clearDates()"
                                                        #clearCalendarTrigger="matMenuTrigger"
                                                        [matMenuTriggerFor]="appMenu"
                                                        >Clear</a
                                                    >
                                                </div>
                                            </div>
                                            @if (showRTOAlertOnStartEndDatesForApnOffer) {
                                                <div class="offer-rto-warning">
                                                    <nova-rto-warning-message
                                                        [enabled]="showRTOAlertOnStartEndDatesForApnOffer">
                                                    </nova-rto-warning-message>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div class="details__item flex-row gap-16">
                                        <mat-label class="details__item--label">RTO Approval</mat-label>
                                        <mat-form-field class="details__item--control">
                                            <mat-select formControlName="rtoApprovalStatus">
                                                <mat-option [value]="1">Approved</mat-option>
                                                <mat-option [value]="2">Pending Approval</mat-option>
                                                <mat-option [value]="3">Not Approved</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                }

                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Shift Type*</mat-label>
                                    <mat-form-field class="details__item--control">
                                        <mat-select formControlName="shiftTypeId">
                                            @for (option of lookups?.shiftTypes; track option) {
                                                <mat-option [value]="option.key">{{ option.value }}</mat-option>
                                            }
                                        </mat-select>
                                        @if (hasError('shiftTypeId', 'required')) {
                                            <mat-error>Shift Type is required</mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Number of Shifts*</mat-label>
                                    <div class="details__item--control flex-row gap-8">
                                        <mat-form-field>
                                            <mat-select
                                                formControlName="shifts"
                                                (selectionChange)="calculateContractDates('numOfShiftsChanged')">
                                                @for (num of shiftValues; track num) {
                                                    <mat-option [value]="num">{{ num }}</mat-option>
                                                }
                                            </mat-select>
                                            @if (hasError('shifts', 'required')) {
                                                <mat-error># of Shifts is required</mat-error>
                                            }
                                        </mat-form-field>

                                        @if (viewAltShift) {
                                            <mat-form-field>
                                                <mat-select formControlName="shiftsAlt">
                                                    @for (num of shiftValues; track num) {
                                                        <mat-option [value]="num">{{ num }}</mat-option>
                                                    }
                                                </mat-select>
                                                @if (hasError('shiftsAlt', 'required')) {
                                                    <mat-error># of Alt Shifts is required</mat-error>
                                                }
                                            </mat-form-field>
                                        }
                                    </div>
                                </div>

                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Shift Length in Hours*</mat-label>
                                    <div class="details__item--control flex-row gap-8">
                                        <mat-form-field>
                                            <mat-select
                                                formControlName="hours"
                                                (selectionChange)="checkRateUpdateFields('Shift Length')">
                                                @for (length of hoursValue; track length) {
                                                    <mat-option [value]="length">{{ length }}</mat-option>
                                                }
                                            </mat-select>
                                            @if (hasError('hours', 'required')) {
                                                <mat-error>Shift Length is required</mat-error>
                                            }
                                        </mat-form-field>
                                        @if (viewAltShift) {
                                            <mat-form-field>
                                                <mat-select
                                                    formControlName="hoursAlt"
                                                    (selectionChange)="onShiftLengthAltChanged()">
                                                    @for (length of hoursValue; track length) {
                                                        <mat-option [value]="length">{{ length }}</mat-option>
                                                    }
                                                </mat-select>
                                                @if (hasError('hoursAlt', 'required')) {
                                                    <mat-error>Alt Shift Length is required</mat-error>
                                                }
                                            </mat-form-field>
                                        }
                                    </div>
                                </div>

                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Shift Time of Day*</mat-label>
                                    <div class="details__item--control flex-row gap-8">
                                        <mat-form-field>
                                            <mat-select
                                                formControlName="shiftTimeOfDayId"
                                                (selectionChange)="checkRateUpdateFields('Shift Time of Day')">
                                                @for (option of lookups?.shiftTimes; track option) {
                                                    <mat-option [value]="option.key">{{ option.value }}</mat-option>
                                                }
                                            </mat-select>
                                            @if (hasError('shiftTimeOfDayId', 'required')) {
                                                <mat-error>Shift Time of Day is required</mat-error>
                                            }
                                        </mat-form-field>
                                        @if (viewAltShift || isRotatingShift) {
                                            <mat-form-field>
                                                <mat-select formControlName="shiftAltTimeOfDayId">
                                                    @for (option of lookups?.shiftTimes; track option) {
                                                        <mat-option [value]="option.key">{{ option.value }}</mat-option>
                                                    }
                                                </mat-select>
                                                @if (hasError('shiftAltTimeOfDayId', 'required')) {
                                                    <mat-error class="extended-error"
                                                        >Alt Shift Time of Day is required</mat-error
                                                    >
                                                }
                                            </mat-form-field>
                                        }
                                    </div>
                                </div>

                                <div class="details__item--gap flex-row gap-16">
                                    <mat-label class="details__item--label">Shift Time (optional)</mat-label>
                                    <div class="flex-row details__item--control gap-8">
                                        <div class="flex-col flex-1 gap-16">
                                            <div class="flex-col gap-8">
                                                <div class="flex-col gap-4">
                                                    <span class="nova__label">Start</span>
                                                    <kendo-timepicker
                                                        class="kendo-input-field"
                                                        formControlName="shiftTimeStart"
                                                        (valueChange)="onTimeStartChanged($event)"
                                                        format="HH:mm"
                                                        [placeholder]="''">
                                                    </kendo-timepicker>
                                                </div>
                                            </div>
                                            <div class="flex-col gap-8">
                                                <div class="flex-col gap-4">
                                                    <span class="nova__label">End</span>
                                                    <kendo-timepicker
                                                        class="kendo-input-field"
                                                        formControlName="shiftTimeEnd"
                                                        (valueChange)="onTimeEndChanged($event)"
                                                        format="HH:mm"
                                                        [placeholder]="''">
                                                    </kendo-timepicker>
                                                </div>
                                            </div>
                                        </div>
                                        @if (viewAltShift || isRotatingShift) {
                                            <div class="flex-col flex-1 gap-16">
                                                <div class="flex-col gap-4">
                                                    <span class="nova__label">Start</span>
                                                    <kendo-timepicker
                                                        class="kendo-input-field"
                                                        formControlName="shiftAltTimeStart"
                                                        (valueChange)="onAltTimeStartChanged($event)"
                                                        format="HH:mm"
                                                        [placeholder]="''">
                                                    </kendo-timepicker>
                                                </div>
                                                <div class="flex-col gap-4">
                                                    <span class="nova__label">End</span>
                                                    <kendo-timepicker
                                                        class="kendo-input-field"
                                                        formControlName="shiftAltTimeEnd"
                                                        (valueChange)="onAltTimeEndChanged($event)"
                                                        format="HH:mm"
                                                        [placeholder]="''">
                                                    </kendo-timepicker>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div class="details__item flex-row gap-16">
                                    <mat-label class="details__item--label">Shift Details</mat-label>
                                    <mat-form-field class="flex-1">
                                        <textarea
                                            matInput
                                            formControlName="shiftDetails"
                                            rows="3"
                                            cdkTextareaAutosize
                                            cdkAutosizeMinRows="3"
                                            cdkAutosizeMaxRows="5">
                                        </textarea>
                                        <mat-hint align="end"
                                            >{{ detailsFormGroup.controls.shiftDetails.value?.length }}/1500
                                            characters</mat-hint
                                        >
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </form>
            </div>

            <div class="right-column"></div>
        </div>
    } @else {
        <div class="offer-details-content flex-row-wrap justify-start gap-16">
            <mat-card class="info">
                <mat-card-content>
                    <ng-template #loading>
                        <div class="progress flex-grow">
                            <mat-progress-spinner
                                mode="indeterminate"
                                diameter="96"></mat-progress-spinner>
                        </div>
                    </ng-template>
                    <form [formGroup]="detailsFormGroup">
                        <table
                            class="offer-info-table"
                            aria-label="table">
                            <tbody>
                                <tr class="hidden">
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Agency *</span></td>
                                    <td>
                                        <mat-form-field
                                            class="mc-form-field mc-form-field__shift-type--width extended-field">
                                            <input
                                                type="text"
                                                matInput
                                                formControlName="vendorValues"
                                                [matAutocomplete]="vendorAuto" />
                                            <mat-autocomplete
                                                #vendorAuto="matAutocomplete"
                                                [displayWith]="displayFieldName"
                                                (optionSelected)="agencySelection($event)">
                                                <mat-option
                                                    *ngFor="let option of filteredVendorIdOptions | async"
                                                    [value]="option"
                                                    [disabled]="!option.hasAcceptedFacilities">
                                                    {{ option.name }}
                                                    {{
                                                        !option.hasAcceptedFacilities ? '(No Accepted Facilities)' : ''
                                                    }}
                                                </mat-option>
                                            </mat-autocomplete>
                                            <mat-error *ngIf="hasError('vendorValues', 'required')"
                                                >Agency is required</mat-error
                                            >
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Candidate *</span></td>
                                    <td>
                                        <mat-form-field>
                                            <input
                                                type="text"
                                                matInput
                                                formControlName="selectedCandidate"
                                                [errorStateMatcher]="matcher"
                                                [matAutocomplete]="candidateAuto" />
                                            <mat-autocomplete
                                                #candidateAuto="matAutocomplete"
                                                (optionSelected)="candidateSelection($event)"
                                                [displayWith]="displayFieldName"
                                                autoActiveFirstOption
                                                #auto="matAutocomplete">
                                                <mat-option
                                                    *ngFor="let option of filteredCandidateIdOptions | async"
                                                    [value]="option"
                                                    [disabled]="!option.userId">
                                                    {{ option.name }}
                                                    {{ !option.userId ? '(no profile)' : '' }}
                                                </mat-option>
                                                <mat-option *ngIf="!filteredCandidateIdOptions"
                                                    >No candidates available to choose from.</mat-option
                                                >
                                            </mat-autocomplete>
                                            <mat-error>Please enter a Candidate.</mat-error>
                                        </mat-form-field>
                                        <span
                                            *ngIf="detailsFormGroup?.controls.selectedCandidate.value"
                                            style="padding-left: 20px"
                                            >{{ detailsFormGroup?.controls.candidateEmail.value }}</span
                                        >
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Agency Contact *</span></td>
                                    <td>
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="vendorContactId">
                                                <mat-option
                                                    *ngFor="let option of vendorLookup?.contacts"
                                                    [value]="option.id"
                                                    >{{ option.name }}</mat-option
                                                >
                                            </mat-select>
                                            <mat-error *ngIf="hasError('vendorContactId', 'required')"
                                                >Agency Contact is required</mat-error
                                            >
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr><td colspan="2"></td></tr>
                                <tr>
                                    <td><span class="label-text">Contract Type</span></td>
                                    <td>
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="contractTypeId">
                                                <mat-option
                                                    *ngFor="let option of lookups?.contracts"
                                                    [value]="option.id"
                                                    >{{ option.code }}</mat-option
                                                >
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Position Type</span></td>
                                    <td>
                                        <span>{{ candidateProfessionTypeName }}</span>
                                    </td>
                                </tr>

                                <tr><td colspan="2"></td></tr>
                                <tr>
                                    <td><span class="label-text">System</span></td>
                                    <td>
                                        <mat-form-field
                                            class="mc-form-field mc-form-field__shift-type--width extended-field full-width">
                                            <input
                                                type="text"
                                                matInput
                                                formControlName="systemValues"
                                                [matAutocomplete]="systemAuto" />
                                            <mat-autocomplete
                                                #systemAuto="matAutocomplete"
                                                [displayWith]="displayFieldName"
                                                (optionSelected)="systemSelection($event)">
                                                <mat-option *ngIf="!filteredSystemIdOptions"
                                                    >No systems available to choose from.</mat-option
                                                >
                                                <mat-option
                                                    *ngFor="let option of filteredSystemIdOptions | async"
                                                    [value]="option"
                                                    >{{ option.name }}</mat-option
                                                >
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Facility *</span></td>
                                    <td>
                                        <mat-form-field
                                            class="mc-form-field mc-form-field__shift-type--width extended-field full-width">
                                            <input
                                                matInput
                                                type="text"
                                                formControlName="facilityValues"
                                                [matAutocomplete]="facilityAuto"
                                                [errorStateMatcher]="matcher" />
                                            <mat-autocomplete
                                                #facilityAuto="matAutocomplete"
                                                [displayWith]="displayFieldName"
                                                (optionSelected)="facilitySelection($event)">
                                                <mat-option *ngIf="!filteredFacilityIdOptions"
                                                    >No facilities available to choose from.</mat-option
                                                >
                                                <mat-option
                                                    *ngFor="let facility of filteredFacilityIdOptions | async"
                                                    [value]="facility"
                                                    >{{ facility.name }} - {{ facility.id }}</mat-option
                                                >
                                            </mat-autocomplete>
                                            <mat-error *ngIf="hasError('facilityValues', 'required')"
                                                >Facility is required</mat-error
                                            >
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">AM</span></td>
                                    <td>
                                        <span>{{ facilityLookup?.accountManager }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span class="label-text">Job Id</span>
                                    </td>
                                    <td>
                                        <mat-form-field>
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="jobId"
                                                [matAutocomplete]="jobIdAuto"
                                                (change)="jobIdSelection($event)" />
                                            <mat-autocomplete
                                                #jobIdAuto="matAutocomplete"
                                                [displayWith]="displayJobIds"
                                                (optionSelected)="jobIdSelection($event)">
                                                <mat-option
                                                    *ngFor="let job of filteredJobIdOptions | async"
                                                    [value]="job"
                                                    >{{ job }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td>
                                        <span class="label-text">Candidate Profession</span>
                                    </td>
                                    <td>
                                        <span>{{ candidateProfessionName }}</span>
                                    </td>
                                </tr>
                                <ng-container>
                                    <tr>
                                        <td colspan="2"></td>
                                    </tr>
                                    <tr>
                                        <td><span class="label-text">Job Profession</span> </td>
                                        <td>
                                            <span>{{ jobProfessionName }}</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="validateCandidateProfessionJobs">
                                        <td colspan="2">
                                            <mat-error
                                                >Clinician's profession must match the job's profession. Please review
                                                and update before creating an Offer.</mat-error
                                            >
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr>
                                    <td>
                                        <span class="label-text">Job Specialty *</span>
                                    </td>
                                    <td>
                                        <mat-form-field
                                            class="mc-form-field mc-form-field__shift-type--width extended-field">
                                            <mat-select
                                                formControlName="expertiseId"
                                                (selectionChange)="checkRateUpdateFields('Expertise')"
                                                [disabled]="!detailsFormGroup.controls.candidateProfessionId.value">
                                                <mat-option
                                                    *ngFor="let option of expertise"
                                                    [value]="option.id"
                                                    >{{ option.name }}</mat-option
                                                >
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr><td colspan="2"></td></tr>
                                <ng-container>
                                    <tr>
                                        <td>
                                            <span class="label-text">Contract Length</span>
                                        </td>
                                        <td>
                                            <div>
                                                <mat-form-field class="contractLength contract-length-small-error">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        (change)="calculateContractDates('weeksLengthChanged')"
                                                        formControlName="contractLength" />
                                                    <mat-error>Please enter valid Weeks Length.</mat-error>
                                                </mat-form-field>
                                                <span class="label-text"> Weeks</span>
                                            </div>
                                            <div>
                                                <mat-form-field class="contractLength contract-length-small-error">
                                                    <input
                                                        type="number"
                                                        matInput
                                                        (change)="calculateContractDates('daysLengthChanged')"
                                                        formControlName="contractLengthDays" />
                                                    <mat-error>Please enter valid Days Length.</mat-error>
                                                </mat-form-field>
                                                <span class="label-text"> Days</span>
                                                <mat-icon
                                                    *ngIf="contractLengthDaysApprovalRequired"
                                                    class="info-icon"
                                                    [matTooltip]="contractLengthDaysInfoMessage"
                                                    >info</mat-icon
                                                >
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label-text">Start</span></td>
                                        <td>
                                            <mat-form-field>
                                                <input
                                                    matInput
                                                    [matDatepicker]="picker"
                                                    formControlName="startDate"
                                                    (dateChange)="calculateContractDates('startDateChanged')"
                                                    data-qa-id="StartDateInput" />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                                <mat-error *ngIf="detailsFormGroup.controls['startDate'].invalid"
                                                    >Please enter valid start date.</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label-text">End</span></td>
                                        <td>
                                            <mat-form-field>
                                                <input
                                                    matInput
                                                    [matDatepicker]="endPicker"
                                                    formControlName="endDate"
                                                    [min]="minEndDate"
                                                    (dateChange)="calculateContractDates('endDateChanged')"
                                                    data-qa-id="EndDateInput" />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="endPicker"></mat-datepicker-toggle>
                                                <mat-datepicker #endPicker></mat-datepicker>
                                                <mat-error *ngIf="detailsFormGroup.controls['endDate'].invalid"
                                                    >Please enter valid end date.</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                </ng-container>

                                <ng-container>
                                    <tr>
                                        <td>
                                            <span class="label-text">Shift Type <span>*</span></span>
                                        </td>

                                        <td>
                                            <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                                <mat-select formControlName="shiftTypeId">
                                                    <mat-option
                                                        *ngFor="let option of lookups?.shiftTypes"
                                                        [value]="option.key"
                                                        >{{ option.value }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftTypeId', 'required')"
                                                    >Shift Type is required</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span class="label-text"># of Shifts <span>*</span></span>
                                        </td>
                                        <td [ngClass]="{ twoColTd: viewAltShift }">
                                            <mat-form-field
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select
                                                    formControlName="shifts"
                                                    (selectionChange)="calculateContractDates('numOfShiftsChanged')">
                                                    <mat-option
                                                        *ngFor="let num of shiftValues"
                                                        [value]="num"
                                                        >{{ num }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shifts', 'required')"
                                                    ># of Shifts is required</mat-error
                                                >
                                            </mat-form-field>

                                            <mat-form-field
                                                *ngIf="viewAltShift"
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select formControlName="shiftsAlt">
                                                    <mat-option
                                                        *ngFor="let num of shiftValues"
                                                        [value]="num"
                                                        >{{ num }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftsAlt', 'required')"
                                                    ># of Alt Shifts is required</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span class="label-text">Shift Length <span>*</span></span>
                                        </td>
                                        <td [ngClass]="{ twoColTd: viewAltShift }">
                                            <div class="tdSplit">
                                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                                    <mat-select
                                                        formControlName="hours"
                                                        (selectionChange)="checkRateUpdateFields('Shift Length')">
                                                        <mat-option
                                                            *ngFor="let length of hoursValue"
                                                            [value]="length"
                                                            >{{ length }}</mat-option
                                                        >
                                                    </mat-select>
                                                    <mat-error *ngIf="hasError('hours', 'required')"
                                                        >Shift Length is required</mat-error
                                                    >
                                                </mat-form-field>
                                                <span class="label-text ml">Hours</span>
                                            </div>
                                            <div
                                                class="tdSplit"
                                                *ngIf="viewAltShift">
                                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                                    <mat-select
                                                        formControlName="hoursAlt"
                                                        (selectionChange)="onShiftLengthAltChanged()">
                                                        <mat-option
                                                            *ngFor="let length of hoursValue"
                                                            [value]="length"
                                                            >{{ length }}</mat-option
                                                        >
                                                    </mat-select>
                                                    <mat-error *ngIf="hasError('hoursAlt', 'required')"
                                                        >Alt Shift Length is required</mat-error
                                                    >
                                                </mat-form-field>
                                                <span class="label-text ml">Hours</span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span class="label-text">Shift Time of Day <span>*</span></span>
                                        </td>
                                        <td [ngClass]="{ twoColTd: viewAltShift || isRotatingShift }">
                                            <mat-form-field
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select
                                                    formControlName="shiftTimeOfDayId"
                                                    (selectionChange)="checkRateUpdateFields('Shift Time of Day')">
                                                    <mat-option
                                                        *ngFor="let option of lookups?.shiftTimes"
                                                        [value]="option.key"
                                                        >{{ option.value }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftTimeOfDayId', 'required')"
                                                    >Shift Time of Day is required</mat-error
                                                >
                                            </mat-form-field>

                                            <mat-form-field
                                                *ngIf="viewAltShift || isRotatingShift"
                                                class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                                <mat-select formControlName="shiftAltTimeOfDayId">
                                                    <mat-option
                                                        *ngFor="let option of lookups?.shiftTimes"
                                                        [value]="option.key"
                                                        >{{ option.value }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error *ngIf="hasError('shiftAltTimeOfDayId', 'required')"
                                                    >Alt Shift Time of Day is required</mat-error
                                                >
                                            </mat-form-field>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span class="label-text">Shift Time</span>
                                            <span class="under-label">Optional</span>
                                        </td>
                                        <td [ngClass]="{ twoColTd: viewAltShift || isRotatingShift }">
                                            <div class="tdSplit">
                                                <table
                                                    class="inner-table"
                                                    aria-label="shift times">
                                                    <tr class="hidden">
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text">Start</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftTimeStart"
                                                                (valueChange)="onTimeStartChanged($event)"
                                                                format="HH:mm">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text">End</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftTimeEnd"
                                                                (valueChange)="onTimeEndChanged($event)"
                                                                format="HH:mm">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div
                                                class="tdSplit"
                                                *ngIf="viewAltShift || isRotatingShift">
                                                <table
                                                    class="inner-table"
                                                    aria-label="alt shift times">
                                                    <tr class="hidden">
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text">Start</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftAltTimeStart"
                                                                (valueChange)="onAltTimeStartChanged($event)"
                                                                format="HH:mm">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><span class="label-text">End</span></td>
                                                        <td>
                                                            <kendo-timepicker
                                                                class="kendo-input-field"
                                                                formControlName="shiftAltTimeEnd"
                                                                (valueChange)="onAltTimeEndChanged($event)"
                                                                format="HH:mm">
                                                            </kendo-timepicker>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label-text">Shift Details</span></td>
                                        <td>
                                            <textarea
                                                formControlName="shiftDetails"
                                                class="other-notes-textarea"></textarea>
                                        </td>
                                    </tr>
                                </ng-container>

                                <tr><td colspan="2"></td></tr>
                                <tr>
                                    <td><span class="label-text">RTO</span></td>
                                    <td>
                                        <mat-checkbox formControlName="hasRequestedTimeOff"></mat-checkbox>
                                    </td>
                                </tr>

                                <ng-container *ngIf="detailsFormGroup.controls.hasRequestedTimeOff.value">
                                    <tr>
                                        <td><span class="label-text">RTO Dates</span></td>
                                        <td>
                                            <div class="rto-container">
                                                <div class="date-input-container">
                                                    <div class="days">
                                                        <span>{{ daysRequested }}</span>
                                                    </div>
                                                    <button
                                                        class="rto-btn"
                                                        mat-icon-button
                                                        [matMenuTriggerFor]="appMenu">
                                                        <mat-icon>event</mat-icon>
                                                    </button>
                                                </div>

                                                <mat-menu
                                                    #appMenu="matMenu"
                                                    class="drop-calendar">
                                                    <div (click)="$event.stopPropagation()">
                                                        <mat-calendar
                                                            #calendar
                                                            class="mat-calendar"
                                                            [dateClass]="dateClass()"
                                                            [maxDate]="maxDate"
                                                            [minDate]="minDate"
                                                            (selectedChange)="dateChanged($event)"></mat-calendar>
                                                    </div>
                                                </mat-menu>

                                                <a
                                                    class="nova-link rto-clear__btn"
                                                    [class.disabled]="daysSelected.length ? false : true"
                                                    (click)="clearDates()"
                                                    #clearCalendarTrigger="matMenuTrigger"
                                                    [matMenuTriggerFor]="appMenu"
                                                    >Clear</a
                                                >
                                            </div>
                                            <div class="offer-rto-warning">
                                                <nova-rto-warning-message
                                                    [enabled]="showRTOAlertOnStartEndDatesForApnOffer">
                                                </nova-rto-warning-message>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label-text">RTO Approval</span></td>
                                        <ng-container>
                                            <td>
                                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                                    <mat-select formControlName="rtoApprovalStatus">
                                                        <mat-option [value]="1">Approved</mat-option>
                                                        <mat-option [value]="2">Pending Approval</mat-option>
                                                        <mat-option [value]="3">Not Approved</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </ng-container>
                                <tr><td colspan="2"></td></tr>
                                <tr>
                                    <td><span class="label-text">Facility Rate</span></td>
                                    <td>
                                        <span class="label-text mr">$</span>
                                        <mat-form-field>
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="facilityRate"
                                                (keyup)="updateVendorRate()"
                                                (change)="calculateContractDates('facilityRateChanged')" />
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="label-text">Vendor Rate</span></td>
                                    <td>
                                        <span class="label-text mr">$</span>
                                        <mat-form-field>
                                            <input
                                                type="number"
                                                matInput
                                                formControlName="vendorRate" />
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr><td colspan="2"></td></tr>
                                <tr>
                                    <td><span class="label-text">Other Details</span></td>
                                    <td>
                                        <textarea
                                            formControlName="otherDetails"
                                            class="other-notes-textarea"></textarea>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </form>
                </mat-card-content>
            </mat-card>
            <mat-card class="notes"> </mat-card>
        </div>
    }
</div>
